import React from "react";
import { COPY } from "@/copy";

export const HowItWorks = () => {
  const steps = [
    { n: "01", title: COPY.how_1_t, body: COPY.how_1_b },
    { n: "02", title: COPY.how_2_t, body: COPY.how_2_b },
    { n: "03", title: COPY.how_3_t, body: COPY.how_3_b },
  ];
  return (
    <section id="how" className="bg-ds-bone ds-border border-l-0 border-r-0 border-t-0">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="ds-mono text-xs uppercase tracking-[0.3em] text-ds-flame mb-4">
          {COPY.section_how}
        </div>
        <h2 className="ds-display text-4xl md:text-6xl mb-12 max-w-3xl">
          {COPY.how_title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s) => (
            <div key={s.n} className="ds-border bg-ds-paper p-7 ds-shadow hover:ds-shadow-lg hover:-translate-y-1 transition-all">
              <div className="ds-mono text-xs uppercase tracking-widest text-ds-flame mb-6">{s.n}</div>
              <div className="ds-display text-2xl md:text-3xl mb-3">{s.title}</div>
              <p className="text-ds-ink/70 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
